import React, { Component } from 'react';
import CommonFunctions from './CommonFunctions';

function swapArrayElements(array, index1, index2) {
	var v = array[index1];
	array[index1] = array[index2];
	array[index2] = v;
}

function getDictionaryIndex(event) {
	return parseInt(event.target.dataset.dictionaryIndex, 10);
}

export default class DictionariesSettings extends Component {
	constructor(props) {
		super(props);
		this.dictionaries = JSON.parse(
					CommonFunctions.getSetting('dictionaries',
						JSON.stringify(
							CommonFunctions.getDefaultDictionariesSettings())));
		this.state = { dictionaries: this.dictionaries };
	}

	updateState() {
		this.setState({ dictionaries: this.dictionaries });
	}

	saveSettings() {
		let dictionaries = JSON.stringify(this.dictionaries);
		if (dictionaries !==
				CommonFunctions.getSetting('dictionaries',
					JSON.stringify(
						CommonFunctions.getDefaultDictionariesSettings()))) {
			CommonFunctions.saveSetting('dictionaries', dictionaries);
			this.props.app.setState({ mode: 'main', status: 'Loading' });
			this.props.app.loadDictionaries();
		} else {
			this.props.app.setState({ mode: 'main' });
		}
	}

	addDictionary() {
		this.dictionaries.push({
				enabled: true,
				name: '',
				spreadsheetUrl: '',
				skipFirstRow: false,
				phraseColumn: 'A',
				translationColumn: 'B'});
		this.updateState();
	}

	addDefaultDictionaries() {
		let defaultDictionaries =
				CommonFunctions.getDefaultDictionariesSettings();
		for (let i = this.dictionaries.length - 1; i >= 0; i--) {
			if (defaultDictionaries.some(v =>
					(v.spreadsheetUrl === this.dictionaries[i].spreadsheetUrl)))
				this.dictionaries.splice(i, 1);
		}
		this.dictionaries = this.dictionaries.concat(defaultDictionaries);
		this.updateState();
	}

	render() {
		let a = [], end = 'Z'.charCodeAt(0);
		for (let i = 'A'.charCodeAt(0); i <= end; i++)
			a.push(String.fromCharCode(i));
		let options = a.map((v, i) => <option key={i}>{v}</option>)
		return (
			<div
					className="box"
					style={{ padding: 10, textAlign: 'left' }}>
				<div className="row header mx-auto">
					<div style={{ fontSize: 'xx-large', textAlign: 'center' }}>
						Dictionaries settings
					</div>

					<table width="100%">
						<tbody>
							<tr>
								<td>
									<button onClick={() => {
												this.addDictionary();
											}}>
										Add dictionary
									</button>
									<button
											style={{ marginLeft: 5 }}
											onClick={() => {
												this.addDefaultDictionaries();
											}}>
										Add default dictionaries
									</button>
								</td>
								<td align="right">
									<button onClick={() => {
												this.saveSettings();
											}}>
										Save
									</button>

									<button
											style={{ marginLeft: 5 }}
											onClick={() => {
												this.props.app.setState(
														{ mode: 'main' });
											}}>
										Close
									</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div className="row content" style={{ border: 'none' }}>

					{
						this.state.dictionaries.map((v, i) =>
	<div key={i}>
		<hr/>
		<table width="100%">
			<tbody>
				<tr>
					<td>
						<input
								type="checkbox"
								id={'enabled-dictionary-' + i}
								data-dictionary-index={i}
								checked={v.enabled}
								onChange={(event) => {
									let index = getDictionaryIndex(event);
									this.dictionaries[index].enabled =
											event.target.checked;
									this.updateState();
								}}/>
						<label htmlFor={'enabled-dictionary-' + i}>
							Enabled
						</label>
					</td>
					<td colSpan="2">
						Name:&nbsp;
						<input
								type="text"
								data-dictionary-index={i}
								value={v.name}
								onChange={(event) => {
									let index = getDictionaryIndex(event);
									this.dictionaries[index].name =
											event.target.value;
									this.updateState();
								}}/>
					</td>
					<td>
						<button
								style={{ width: '100%' }}
								data-dictionary-index={i}
								onClick={(event) => {
									let index = getDictionaryIndex(event);
									if (!index) return;
									swapArrayElements(
										this.dictionaries, index, index - 1);
									this.updateState();
								}}>
							Move up
						</button>
					</td>
				</tr>
				<tr>
					<td colSpan="3">
						Spreadsheet url:&nbsp;
						<input
								data-dictionary-index={i}
								size="60"
								value={v.spreadsheetUrl}
								onChange={(event) => {
									let index = getDictionaryIndex(event);
									this.dictionaries[index].spreadsheetUrl =
											event.target.value;
									this.updateState();
								}}/>
						&nbsp;
						<span
							className="link"
							data-dictionary-index={i}
							onClick={(event) => {
								let index = getDictionaryIndex(event);
								let url = this.dictionaries[index].spreadsheetUrl;
								if (url !== '') {
									let win = window.open(url, '_blank');
									if (win) win.focus();
								}
							}}>
							Open
						</span>
					</td>
					<td>
						<button
								style={{ width: '100%' }}
								data-dictionary-index={i}
								onClick={(event) => {
									let index = getDictionaryIndex(event);
									if (index === (this.dictionaries.length - 1))
										return;
									swapArrayElements(
										this.dictionaries, index, index + 1);
									this.updateState();
								}}>
							Move down
						</button>
					</td>
				</tr>
				<tr>
					<td>
						<input
								type="checkbox"
								id={'skip-first-row-' + i}
								data-dictionary-index={i}
								checked={v.skipFirstRow}
								onChange={(event) => {
									let index = getDictionaryIndex(event);
									this.dictionaries[index].skipFirstRow =
											event.target.checked;
									this.updateState();
								}}/>
						<label htmlFor={'skip-first-row-' + i}>
							Skip first row
						</label>
					</td>
					<td>
						Phrase column:&nbsp;
						<select
								data-dictionary-index={i}
								value={v.phraseColumn}
								onChange={(event) => {
									let index = getDictionaryIndex(event);
									this.dictionaries[index].phraseColumn =
											event.target.value;
									this.updateState();
								}}>
							{options}
						</select>
					</td>
					<td>
						Translation column:&nbsp;
						<select
								data-dictionary-index={i}
								value={v.translationColumn}
								onChange={(event) => {
									let index = getDictionaryIndex(event);
									this.dictionaries[index].translationColumn =
											event.target.value;
									this.updateState();
								}}>
							{options}
						</select>
					</td>
					<td align='center'>
						<button
								data-dictionary-index={i}
								onClick={(event) => {
									let index = getDictionaryIndex(event);
									this.dictionaries.splice(index, 1);
									this.updateState();
								}}>
							Delete
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>)
					}
				</div>
			</div>
		);
	} // render
}



// WEBPACK FOOTER //
// ./src/DictionariesSettings.js